import { WidgetViewModel } from './WidgetViewModel';
import { EditorDOMElements, EditorDOMUtils } from 'Editor/services/_Common/DOM';
import { ResizableWidgetView } from '../../Views';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';

export class ResizableWidgetModel extends WidgetViewModel<'resizable'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['resizable']['view'],
    props: Editor.Visualizer.WidgetDataMapper['resizable']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.dataset.type = 'resizable';
  }

  render() {
    const parent = this.container.parentElement;
    const ref = this.refView;
    const offsets = EditorDOMUtils.getOffsets(ref);

    if (offsets) {
      const zoom = ReduxInterface.getZoomValue() || 1;

      this.container.style.position = 'absolute';
      this.container.style.top = `${offsets.top}px`;

      if (this.Visualizer.getLayoutType?.() === 'PAGE') {
        if (parent && ref) {
          const refLeft = ref.getBoundingClientRect().left;
          const parentLeft = parent.getBoundingClientRect().left;
          this.container.style.left = `${(refLeft - parentLeft) / zoom}px`;
        }
      } else {
        this.container.style.left = `${offsets.left}px`;
      }

      this.container.style.width = `0px`;
      this.container.style.height = `${offsets.height / zoom}px`;

      let corners;
      let sides;
      let aspectRatio = true;
      let max: { width?: number; height?: number } | undefined;

      if (EditorDOMElements.isTableElement(this.refView)) {
        aspectRatio = false;
        corners = {
          ne: true,
          se: true,
          sw: true,
        };
        sides = {};
        max = { width: 2111.622 };
      }

      // mount react component
      this.renderReactComponent(
        <ResizableWidgetView
          rect={offsets}
          corners={corners}
          sides={sides}
          resize={this.refView.resizeElement}
          keepAspectRatioByDefault={aspectRatio}
          max={max}
        />,
      );
    }
  }
}
